import React from 'react';

import { MapSearch } from '../../../components';

const ParagraphMap: React.FC = () => (
  <div className="Paragraph ParagraphMap">
    <div>
      <MapSearch />
    </div>
  </div>
);

export default ParagraphMap;
